<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [variante]="variante"
  [(ngModel)]="idsCanaisMidiasSociais"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
